/**
 * Client-side mirror of src/shared/models/ServiceTier.js DEFAULT_FEATURES.
 * Kept intentionally minimal: the backend is the authority on feature
 * entitlements (via orgHasFeature / requireFeature), and this is only used
 * by FeatureRoute to avoid showing navigation the org cannot reach.
 */

// Mirror of ServiceTier.PREMIUM_FEATURES (docs/Decisions.md D42..D44).
export const PREMIUM_FEATURES = ['ribbon-designer', 'badge-visibility', 'site-upload', 'payments-advanced'];

const TIER_FEATURES = {
  base: ['video-hosting', 'events', 'calendar', 'groups'],
  mid: ['video-hosting', 'events', 'calendar', 'groups', 'inbox', 'forums', 'tasks'],
  top: [
    'video-hosting', 'events', 'calendar', 'groups', 'inbox', 'forums',
    'tasks', 'verification', 'custom-roles', 'saml-sso', 'api-access',
    ...PREMIUM_FEATURES,
  ],
};

const ROUTE_TO_TIER_FEATURE = {
  videos: 'video-hosting',
  forum: 'forums',
};

export function orgTierHasFeature(tier, routeFeature) {
  const tierId = tier || 'base';
  const features = TIER_FEATURES[tierId] || TIER_FEATURES.base;
  const featureId = ROUTE_TO_TIER_FEATURE[routeFeature] || routeFeature;
  return features.includes(featureId);
}
